export default "__VITE_ASSET__5ad144f6__"